import ColourPicker from "PFComponents/colour_picker/colour_picker";
import ConfirmModal from "PFComponents/confirm/confirm_modal";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { IDataItem } from "../types";
import css from "./edit_thresholds_modal.module.scss";

interface IEditModalProps {
  onClose: () => void;
  selectedItem: IDataItem;
  setEditedColor: any;
}

const EditThresholdsModal = ({ onClose, selectedItem, setEditedColor }: IEditModalProps) => {
  const { t } = useTranslation("bookingModule");
  const [color, setColor] = useState<IDataItem["color"] | null>(selectedItem.color || "#fff");

  return (
    <ConfirmModal
      handleOK={() => setEditedColor({ ...selectedItem, color: color })}
      handleClose={onClose}
      labelOK="Save"
      style={{ maxWidth: 430 }}
    >
      <div className={css.wrapper}>
        <h3>{t("config.thresholds.color")}</h3>
        <ColourPicker onClick={setColor} selected={color} className={css.colorPicker} />
      </div>
    </ConfirmModal>
  );
};

export default EditThresholdsModal;
